export default "__VITE_ASSET__DrKBl4Ip__"